module.exports = __webpack_public_path__ + "img/home-green.a3974242.png";